import { useState } from "react"

export const TrainingVideoState = () => {
    const [ isModal ,setIsModal ] = useState({open: false, mode:''});
    const [ allTopic , setAllTopic ] = useState([]);
    const [ listVideo , setListVideo ] = useState([]);
    const [videoTopic, setVideoTopic] = useState({
        topic_id:'',
        trainings:[{id:'', link:''}],
        course:''
    })
    const [videoTopicValid, setVideoTopicValid] = useState({
        topic_id:false,
        trainings:[{id:false, link:false}],
        course:false
    })

    const [isOpen, setIsOpen] = useState(false);
    const [sloader, setSloader] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    return {
        isOpen: {data: isOpen, set: setIsOpen},
        sloader: {data: sloader, set: setSloader},
        isLoading: {data: isLoading, set: setIsLoading},
        isModal: {data: isModal, set: setIsModal},
        allTopic: {data: allTopic, set: setAllTopic},
        listVideo: {data: listVideo, set: setListVideo},
        forms: {data: videoTopic, set: setVideoTopic},
        validate: {data: videoTopicValid, set: setVideoTopicValid},
    }
}

export const TrainingTopicState = () => {
    const [topic, setTopic] = useState({
        file: {value: null, object: null, name: 'default_avatar', type: 'default', size: 0, updated: false, stat: false, msg: ''},
        link: '',
        mode: '',
        title: '',
        speaker_id: '',
        profession: '',
        programaccreditation: '',
        competencearea: '',
        cpd: 1.5,
        date: '',
        method:'',
        training_type: '',
        image:'',
        courseid:'',
        description: '',
        objectives: '',
        skill_type: '',
        course:'',
        is_exclusive: 0,
        public: 0,
        active: 0,
        employees:[],
        more_topics:[{title:'',description:'',objectives:'', programaccreditation:'', competencearea:'', cpd:1.5, date:''}]
    })
    const [ validateTopic, setValidateTopic ] = useState({
        file: { 
            type: false,
            name: false,
            size: false,
            value: false
        },
        mode: false,
        link: false,
        title: false,
        speaker_id: false,
        course: false,
        profession: false,
        training_type: false,
        programaccreditation: false,
        competencearea: false,
        cpd: false,
        date: false,
        description: false,
        objectives: false,
        skill_type: false,
        employees: false,
        more_topics: [{title:false,description:false,objectives:false, programaccreditation:false, competencearea:false, date:false}],
    })
    
    const [ imageUpload , setImageUpload] = useState(false);
    const [topicList, setTopicList] = useState([]);
    const [eModal, setEModal] = useState(false);
    const [open, setOpen] = useState(false);
    const [openHandlePost, setOpenHandlePost] = useState(false);
    const [sloader, setSloader] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [getTitle, setGetTitle] = useState({title: '', id:'', course:'', company_id:'', user_id: '', is_exclusive:''});
    const [ isModal ,setIsModal ] = useState({open: false, mode:'', type: ''});

    return {
        forms: {data: topic, set: setTopic},
        imageUpload: {data: imageUpload, set: setImageUpload},
        topicList: {data: topicList, set: setTopicList},
        validate: {data: validateTopic, set: setValidateTopic},
        open: {data: open, set: setOpen},
        openHandlePost: {data: openHandlePost, set: setOpenHandlePost},
        sloader: {data: sloader, set: setSloader},
        message: {data: message, set: setMessage},
        getTitle: {data: getTitle, set: setGetTitle},
        isLoading: {data: isLoading, set: setIsLoading},
        tforms: {data: topic, set: setTopic},
        emodal: {data: eModal, set: setEModal},
        isModal: {data: isModal, set: setIsModal},
    }
}

export const TrainingState = () => {
    const [rLoader, setRLoader] = useState(false);
    const [nLoader, setNLoader] = useState(false);

    //currentSlide for kneel slider
    const [currentSlideNew, setCurrentSlideNew] = useState(0);
    const [currentSlideRecom, setCurrentSlideRecom] = useState(0);
    
    //MainContent Loader
    const [successOpen, setSuccessOpen] = useState(false);
    const [successSaving, setsuccessSaving] = useState(false);
    
    // REVISED STATES
    const [list, setList] = useState({filter: {toggled: false, profession: 0}, cpd: null, sdl: null, upcoming: null, webinar: null})
    const [search, setSearch] = useState({filter: {toggled: false, profession: 0}, input: {value: '', stat: false, msg: ''}, list: 1})
    const [tnew, setTnew] = useState(null)
    const [recommended, setRecommended] = useState(null)
    const [all, setAll] = useState([])
    const [preview, setPreview] = useState({})
    const [summaryCount, setSummaryCount] = useState({all:0, completed:0, enrolled: 0, ongoing: 0})
    const [tl, setTL] = useState({filter: {toggled: false, status: 'all'}, all: null, training: null, courses: null, technical: null, core: null})
    const [exclusive, setExclusive] = useState({code: null, step: 1, list: null, active: 'all',
        form: {
            toggled: false,
            loader: false,
            inputs: {value: '', stat: false, msg: ''},
        },
        filter: {toggled: false, status: 'all'}
    })
    
    // Trainings
    const [newType, setNewType] = useState(1)
    const [recommendedType, setRecommendedType] = useState(1)
    const [acad, setAcad] = useState({tnew: null, recommended: null})
    const [seeAll, setSeeAll] = useState({tnew: false, recommended: false});
    const [tredirection, setTredirection] = useState({stat: false, training: null})
    const [info, setInfo] = useState({list:null, detailed: false, preview: null, remove: null, premove: false, restore: false})
    const [typeTC, setTypeTC] = useState("training")
    
    return {
        sc: {data: summaryCount, set: setSummaryCount},
        csn: {data: currentSlideNew, set: setCurrentSlideNew},
        csr: {data: currentSlideRecom, set: setCurrentSlideRecom},
        tnew: {data:tnew, set:setTnew},
        recommended: {data:recommended, set:setRecommended},
        recomloader: {data:rLoader, set:setRLoader},
        newloader: {data:nLoader, set:setNLoader},
        successOpen: {data: successOpen, set: setSuccessOpen},
        successSaving: {data: successSaving, set: setsuccessSaving},
        newType: {data: newType, set: setNewType},
        recommendedType: {data: recommendedType, set: setRecommendedType},
        acad: {data: acad, set: setAcad},
        seeAll: {data: seeAll, set: setSeeAll},
        all: {data: all, set: setAll},
        list: {data: list, set: setList},
        search: {data: search, set: setSearch},
        preview: {data: preview, set: setPreview},
        tredirection: {data: tredirection, set: setTredirection},
        exclusive: {data: exclusive, set: setExclusive},
        info: {data: info, set: setInfo},
        tl: {data: tl, set: setTL},
        typeTC: {data: typeTC, set: setTypeTC},
    }
}